import React from 'react';
import IndexContext from '../contexts/IndexContext.js';
import { typeof as _typeof } from '../_virtual/_rollupPluginBabelHelpers.js';
import useModelKeyName from '../hooks/use-model-key-name.js';
import shortid from 'shortid';
import { observer } from 'mobx-react';
import useCollection from './hooks/use-collection.js';

function ForEach(props) {
  var collection = useCollection();
  var modelKeyName = useModelKeyName();
  return collection.map(function (entry, index) {
    var entryKey = null;

    if (typeof entry.__unique_key !== 'undefined') {
      entryKey = entry.__unique_key;
    } else {
      if (!!modelKeyName) {
        if (typeof entry.get === 'function') {
          entryKey = entry.get(modelKeyName);
        } else if (typeof entry[modelKeyName] !== 'undefined') {
          entryKey = entry[modelKeyName];
        }
      }
    }

    if (!entryKey) {
      entryKey = shortid();
    }

    if (_typeof(entry) === 'object' && entry !== null) {
      entry.__unique_key = entryKey;
    }

    return /*#__PURE__*/React.createElement(IndexContext.Provider, {
      value: index,
      key: entryKey
    }, props.children);
  });
}

var ForEach$1 = observer(ForEach);

export default ForEach$1;
//# sourceMappingURL=ForEach.js.map
